import { render, staticRenderFns } from "./ContactQ.vue?vue&type=template&id=050cd42a&"
import script from "./ContactQ.vue?vue&type=script&lang=ts&"
export * from "./ContactQ.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports